<template><SimpleModuleDashboard :module-id="Modules.RECIBOS_ERP" :profile-id="Profiles.PERSONAL" include-php-custom :actions="dashboardActions" /></template>
<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import Param from '@/config/parameters'
import Helper from '@/handler/helper'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'
export default {
  components: { SimpleModuleDashboard },
  data: () => ({ Modules, Profiles, allowReceiptsTrashed: Helper.hasParametersAccess(Param.P40) }),
  computed: {
    dashboardActions() {
      const actions = [{ id: 'receipts', reference: 'receipts', route: 'ReceiptsErpStaffReceipts', tone: 'primary' }]
      if(this.allowReceiptsTrashed) actions.unshift({ id: 'receiptsTrashed', reference: 'receiptsTrashed', route: 'ReceiptsErpStaffReceiptsTrashed', tone: 'warning' })
      return actions
    },
  },
}
</script>
